import React, {useState, useContext} from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Pressable, Text, View } from 'react-native';
import { CORRESPONDENCE_WITH_COUNT } from './queries';
import { useMutation } from '@apollo/client';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import AuthContext from '../../contexts/AuthContext';
import { rest } from '../../utils/rest';
import FileDownload from 'js-file-download';

import { UPDATE_ASSET_RELEASE_SENT } from 'app/src/components/Assets/queries';

import {
  CorrespondenceContainer
} from './elements';
import { MainContainer, PageTitle } from '../../elements';

const inputStyle = {
  marginBottom: '10px'
}

const Correspondence = (props) => {
  const { resourceType, resourceId } = props;
  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const { credentials } = useContext(AuthContext);
  const queryVariables = {
    resourceType: resourceType,
    resourceId: resourceId,
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const [updateReleaseSent] = useMutation(UPDATE_ASSET_RELEASE_SENT);

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const downloadRelease = (assetId, vin, name) => {
    const options = {
      credentials,
      params: { assetId: assetId },
      path: `download-release`,
      headers: {
        Accept:
          'application/pdf',
      }
    };

    rest(options).then(response => {
      response.blob().then(blob => FileDownload(blob,
        `${vin}-${name.replace(/\s/g, "")}-Release.pdf`
      ));
    });
  }

  const columns = [
    {
      key: 'action',
      label: 'Type',
      // width: '20%',
      content: (entry) => {
        return entry.entry.action
      }
    },
    {
      key: 'asset',
      label: 'Asset',
      value: ({ value }) => `${value?.vin} - ${value?.name}`,
      content: ({ entry, value }) => (
        entry.asset ?
          <Link to={entry.asset.webPath}><Text>{value}</Text></Link> : null
      )
    },
    {
      key: 'seller',
      label: 'Seller',
      // width: '20%',
      content: (entry) => {
        return entry.entry.asset?.seller?.name
      }
    },
    {
      key: 'buyer',
      label: 'Buyer',
      // width: '20%',
      content: (entry) => {
        return entry.entry.buyer?.name
      }
    },
    {
      key: 'recipients',
      label: 'Sent To',
      // width: '20%',
      content: (entry) => {
        let emails = JSON.parse(entry.entry.recipientList)
        if(emails) {
          return (
            <View>
              {emails.buyer_email_to !== undefined &&
                <Text><b>Buyer: </b>{emails.buyer_email_to}</Text>
              }
              <Text>
                <b>Users: </b>{emails?.user_emails_to?.join(', ')}
              </Text>
            </View>
          )
        }
      }
    },
    {
      key: 'user',
      label: 'Created By',
      // width: '20%',
      content: (entry) => {
        if(entry.entry.userLog.user) {
          return `${entry.entry.userLog?.user?.firstName}
          ${entry.entry.userLog.user?.lastName}`
        }else {
          return 'System'
        }
      }
    },
    {
      key: 'createdAt',
      label: 'Sent At',
      // width: '20%',
      content: (entry) => {
        return moment(entry.entry.createdAt).format('M/D/YY h:mm a')
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => (
        <>
          <Pressable
            onPress={() => downloadRelease(
              parseInt(entry.entry.asset.id),
              entry.entry.asset.vin,
              entry.entry.asset.name
            )}
          >
            <Text>Download</Text>
          </Pressable>
          <Pressable
            onPress={() => createRelease(entry.entry.asset)}
          >
            <Text>Resend</Text>
          </Pressable>
        </>
      )
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Asset:</Text>
          <input
            type={'text'}
            name="asset"
            onChange={e => setFilter('asset', e.target.value)}
            value={filters.asset || ''}
            style={inputStyle}
          />
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <CorrespondenceContainer>
        <PageTitle><Text>Releases</Text></PageTitle>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={CORRESPONDENCE_WITH_COUNT}
          queryName='correspondenceWithCount'
          columns={columns}
          // buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.correspondenceWithCount)}
          htmlTable
          queryVariables={queryVariables}
        />
      </CorrespondenceContainer>
    </MainContainer>
  )

  function createRelease(asset) {
    if (window.confirm('Resend Release?')) {
      updateReleaseSent({
        variables: {
          id: parseInt(asset?.id),
          releaseSentAt: moment()._d
        }
      })
    }
  }
}

export default Correspondence;
